﻿myApp.directive('tabhandler', function () {
    return {
        link: function (scope, elm) {
            if (scope.$first) {
                scope.tab.state = "tab-show";

            }
        }
    }
});
myApp.directive('iconhandler', function () {
    return {
        link: function (scope, elm) {
            if (scope.$first) {
                scope.th.state = "on";
            }
        }
    }
});
myApp.controller("tabsCtrl", ['$scope', '$http', function ($scope, $http) {
    $scope.Title = "tabs";
    $scope.tabs = [];
    $scope.tabheaders = [];
    $scope.current = 0;
    $scope.getAll = function () {
        $http.get("/shared/gettabs")
            .then(function (data) {
                var xml = $.parseXML(data.data);
   
                $(xml).find("tabs tab").each(function () {
                    var header = $(this).find("header").find($scope.lang).text().trim();
                    var p = $(this).find("p").find($scope.lang).text().trim();
                    var headline = $(this).find("headline").find($scope.lang).text().trim();
                     
                    var img = $(this).find("img").text().trim();
                    var ref = $(this).find("ref").text().trim();
                    var chars = $(this).find("header").attr("char");
                    var char;
                    var isCms = ref == "cms";
                    if (chars == "eng"&&$("body").hasClass("heb")) {
                         
                        char = "Fauna One !important";
                     }

                    $scope.tabs.push({
                        header: header,
                        img: img,
                        p: p,
                        headline: headline,
                        ref: ref,
                        char: char,
                        isCms: isCms,
                        state: "tab-hide"
                    });
                    $scope.tabheaders.push({
                        header: header,
                        ref: ref,
                        char:char,
                        state: "off"
                    });
                });

            });
    }
    //on tab click
    $scope.iconClick = function (icon, index, e) {
        e.preventDefault();
        console.log("icon clicked");
        for (var i = 0; i < this.tabheaders.length; i++) {
            this.tabheaders[i].state = "off";
        }
        icon.state = "on";
        $scope.switchTab(index);
        $scope.current = index;
    }
    // switch tab
    $scope.switchTab = function (index) {
        var arr = this.tabs;
        for (var i = 0; i < arr.length; i++) {
            arr[i].state = "hide";
        }

        this.tabs[index].state = "tab-show";
        $scope.moveDot(index);
    }
    // move dot on indicator
    $scope.moveDot = function (index) {
        var elm = $('.tabs-sec li[data-index="' + index + '"]');
        if (innerWidth > 992) {
            $("#dot").css("right", "initial");
            var extraSpace = $(".tabs-sec li").first().position().top;
            var middleHeight = $(elm).height() * 0;
            var donwPx = $(elm).position().top - extraSpace + middleHeight;

            if (index == $(".tabs-sec li").length - 1) {
                $("#dot").css("top", $("#line").height() - 15);
            }
            else {
                $("#dot").css("top", donwPx);
            }
        }
        else {
            $("#dot").css("top", "-8px");
            //$("#dot").css("left", "initial");
            var lineeWidth = $("#line").width();
            var offsetlfet = $(elm).offset().left - 18;
            var ballwidth = $("#dot").width()*0.5
            var totalRight = lineeWidth - offsetlfet - ballwidth;
            $("#dot").css("right", totalRight);
            //$("#dot").animate({ "right": totalRight });
        }
    }
    //init 
    function init() {

        $scope.getAll();
        $(window).on("resize", function () {
            $scope.moveDot($scope.current);
        });
    }
    init();

}]);




//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/tabs.js
// module id = 17
// module chunks = 0